import { Navigate } from 'react-router-dom';
import { useEntity } from '@/hooks/useEntity';
import { ProfileEditor } from '@/features/profiles/ProfileEditor';
import { ROUTES } from '@/lib/constants/routes';

/**
 * Thin container for the persona profile routes (`/startup/profile`,
 * `/investor/profile`, `/partner/profile`). It supplies the active `entity` and
 * lets the feature resolve the typed module; it does not fetch or branch. One
 * page backs all three routes - the persona split lives in the guarded routes,
 * not here (ADR FE-1). Falls back to the account page if there is no entity.
 */
export function EntityProfilePage() {
  const entity = useEntity();
  if (!entity) return <Navigate to={ROUTES.ACCOUNT} replace />;
  return <ProfileEditor entity={entity} />;
}
